import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Stamps a server-side `endedAt` on one of the caller's own activity-log rows
 * (generic across action types). `sk` is the handle from the create response
 * (e.g. postImageView's `activityLog.sk`). Returns `{ ok, endedAt }`, or
 * `{ ok: false }` when the row is missing/already ended — ending is best-effort
 * by design (a closed tab never sends one).
 */
export const patchEndActivityLog = async ({
  projectId,
  sk,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const apiPath = `activity-log/project/${projectId}/end`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { sk },
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
